import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session'; // still using sessionStorage
import { combineReducers } from 'redux';

import appFilterAndSortReducer from './appFilterAndSort/reducer';
import homepageReducer from './homepage/reducer';
import initReducer from './init/reducer';
import requestsReducer from './requests/reducer';

import bookingReducer from './booking/booking/reducer';
import bookingFormReducer from './booking/form/reducer';
import bookingExtrasReducer from './booking/extras/reducer';
import bookingPaymentReducer from './booking/payment/reducer';
import previousBookingReducer from './booking/previousBooking/reducer';

import channelsReducer from './data/channels/reducer';
import regionsReducer from './data/regions/reducer';
import filtersReducer from './data/filters/reducer';
import operatorsReducer from './data/operators/reducer';
import parkDetailsReducer from './data/park/details/reducer';
import parkResultsReducer from './data/park/results/reducer';
import parkReviewsReducer from './data/park/reviews/reducer';
import parksReducer from './data/parks/reducer';
import unitTypesReducer from './data/unitTypes/reducer';
import cachedAvailReducer from './data/cachedAvail/reducer';

import offersReducer from './offers/reducer';

import pageBrowseOperatorRegionsReducer from './pages/browseOperatorRegions/reducer';
import pageBrowseOperatorsReducer from './pages/browseOperators/reducer';
import pageBrowseParksReducer from './pages/browseParks/reducer';
import pageBrowseRegionsReducer from './pages/browseRegions/reducer';

import parkReducer from './park/reducer';

import searchFormReducer from './search/form/reducer';
import searchResultsReducer from './search/results/reducer';

import userReducer from './user/reducer';
import { blogReducer } from './blog/blogSlice';

const dataPersistConfig = {
  key: 'data',
  storage,
  blacklist: ['cachedAvail'], // do NOT persist cachedAvail, it exceeds >5mb so can't be stored
};

const dataReducer = combineReducers({
  channels: channelsReducer,
  filters: filtersReducer,
  operators: operatorsReducer,
  parks: parksReducer,
  park: combineReducers({
    details: parkDetailsReducer,
    results: parkResultsReducer,
    reviews: parkReviewsReducer,
  }),
  regions: regionsReducer,
  unitTypes: unitTypesReducer,
  cachedAvail: cachedAvailReducer,
});

const persistedDataReducer = persistReducer(dataPersistConfig, dataReducer);

export const reducers = combineReducers({
  appFilterAndSort: appFilterAndSortReducer,
  booking: combineReducers({
    booking: bookingReducer,
    form: bookingFormReducer,
    extras: bookingExtrasReducer,
    payment: bookingPaymentReducer,
    previousBooking: previousBookingReducer,
  }),
  data: persistedDataReducer,
  blog: blogReducer,
  offers: offersReducer,
  homepage: homepageReducer,
  init: initReducer,
  pages: combineReducers({
    browseOperatorRegions: pageBrowseOperatorRegionsReducer,
    browseOperators: pageBrowseOperatorsReducer,
    browseParks: pageBrowseParksReducer,
    browseRegions: pageBrowseRegionsReducer,
  }),
  park: parkReducer,
  requests: requestsReducer,
  search: combineReducers({
    form: searchFormReducer,
    results: searchResultsReducer,
  }),
  user: userReducer,
});
